import type { LocaleMessages } from '../types';

export const en: LocaleMessages = {
  app: {
    brand: 'ACEX · Agent Capital Exchange',
    title: 'Pulse Terminal',
  },
  locale: {
    label: 'Language',
  },
  header: {
    chain: 'Chain',
    refresh: 'refresh {ms}ms',
    chainFilterUniOnly: 'Chain filter applies in LIVE only',
  },
  contour: {
    live: 'LIVE',
    uni: 'UNI',
    liveBadge: 'LIVE · {mode}',
    uniBadge: 'UNI · {phase}',
  },
  dataSource: {
    live: {
      label: 'LIVE · Factory / Hub',
      formula:
        'Product capabilities (hub catalog) → ACEX v0.2 averages per listing; chain filter on capabilities',
    },
    uni: {
      label: 'UNI · Alien Monitor',
      formula:
        'Graph metrics → $/call proxy → ACEX v0.2 (NAV = $/call × success × trust × 100; index = $/call × success × 1000)',
    },
  },
  dataSourceBar: {
    loading: 'loading…',
  },
  error: {
    uniHint: 'ensure Alien Monitor is running (/monitor/, UNI mode)',
    liveHint: 'ensure API at /api/v2/capital/pricing (factory :9081)',
  },
  panel: {
    agentListings: 'Agent listings',
    agentListingsSub: 'CapShares · live NAV',
    universeListings: 'Universe listings',
    universeListingsSub: 'UNI contour · Alien Monitor graph',
    agentListing: 'Agent listing',
    selectRow: 'select row',
    selectHint:
      'Choose a listing to inspect CapShare NAV, index components, and CapSense series.',
    listingFallback: 'Listing',
  },
  listings: {
    emptyLive: 'No listings — start factory pipeline or hub with capabilities',
    emptyUni: 'No universe nodes — start Alien Monitor (UNI mode)',
    caps: '{count} caps',
    capabilities: '{count} capabilities',
    capShareNav: 'CapShare NAV',
    trust: 'trust {pct}%',
    idx: 'idx {value}',
    details: 'Details →',
    colListing: 'Listing',
    colCapShare: 'CapShare',
    colIndex: 'Index',
    colIv: 'IV',
    colTrust: 'Trust',
    colAudit: 'Audit',
    colRoute: 'Route',
    colTrend: 'Trend',
    iv: 'IV {pct}%',
    uncovered: 'uncovered',
    watch: 'watch',
  },
  detail: {
    uniSubtitle: 'UNI · NAV from monitor graph (ACEX v0.2)',
    liveSubtitle: 'LIVE · CapShare from product capabilities',
    capShareNav: 'CapShare NAV',
    indexLevel: 'Index level',
    iv: 'IV',
    pricePerCall: '$/call',
    success30d: 'Success 30d',
    trustScore: 'Trust score',
    reliability: 'Reliability',
    indexComponents: 'Index components',
    change24h: '24h {value}',
    capsenseTitle: 'CapSense Options',
    capsenseSub: 'Phase 2 · Solana',
    openSeries: 'Open series',
    capsenseHint: 'Calls on revenue index · expiries {days}d',
    liquidityTitle: 'Liquidity mesh',
    liquiditySub: 'routing',
    poaTitle: 'Proof-of-Audit',
    poaSub: 'staked auditor cover · invoke fee share',
    insured: 'Insured',
    noCover: 'No cover',
    aggregateScore: 'Aggregate score',
    totalCover: 'Total cover',
    auditors: 'Auditors',
    auditFee: 'Audit fee',
    accruedRewards: 'Accrued rewards',
    noteSpread: 'Note spread',
    baseline: 'Baseline {value}',
    twap: 'TWAP {value}',
    drawdown: 'drawdown {pct}%',
    coverLine: 'cover {value}',
    scoreLine: 'score {pct}%',
    pendingLine: 'pending {value}',
  },
  defaultRisk: {
    none: 'Default risk: low',
    watch: 'Default risk: watch',
    elevated: 'Default risk: elevated',
    defaulted: 'Default risk: defaulted',
  },
  statusBar: {
    acex: 'ACEX {version}',
    listings: '{count} listings',
    latency: '{ms}ms',
    navSum: 'Σ NAV {value}',
    version: 'Pulse v0.1',
  },
  mobile: {
    close: 'Close',
  },
  ticker: {
    uni: 'uni',
  },
};
